import {Deserializable} from "./deserializable.model";

export class AllRecipients {


subject_contact_email_id: number;
recipient_name: string;
recipient_email_address: string;
recipient_brand_id: string;
recipient_brand_type_id: number;
recipient_user_id: number;
recipient_user_level_id: number;
recipient_type_name: string;
  subject_id: any;

  // ? what does this really do? (no encoding or deserialisation required...)
  deserialize(input: any): AllRecipients {
    Object.assign(this, input);

    return this;
  }


}



